// ***************************************
// Definition of game token SpineEffect
// ***************************************
import { tbGame } from "../engine/tbGame";
import { PhysicsSettings } from "../settings/PhysicsSettings";
// The constructor for the ExplosionToken game token.
export var SpineEffect = function (x, y, effect, effectPlay, container, extraScale, event, callback, context, onComplete) {
    "use strict";
    // Properties used by the engine
    this.animation = effect.clone();
    this.effect = effectPlay;
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.x = x;
    this.y = y;
    this.container = container;
    this.finished = false;
    this.timeRemove = 100;
    this.extraScale = (extraScale === undefined) ? 1 : extraScale;
    this.event = event;
    this.callback = callback;
    this.context = context;
    this.onComplete = onComplete;
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game.
SpineEffect.prototype.handleAdd = function () {
    "use strict";
    var self = this;
    var scale = (1 / PhysicsSettings.textureResolution);
    this.animation.setAnimation(this.effect, false);
    this.animation.setScale(scale * this.extraScale);
    this.animation.setPosition(this.x, this.y);
    this.animation.setOnComplete(function () {
        self.finished = true;
        if (self.onComplete) {
            self.onComplete();
        }
    });
    if (this.event)
        this.animation.setEventCallback(this.event, this.callback, this.context);
    this.container.addChild(this.animation);
};
SpineEffect.prototype.setSpeed = function (speed) {
    "use strict";
    if (this.animation) {
        this.animation.setSpeed(speed);
    }
};
SpineEffect.prototype.setScale = function (scale) {
    "use strict";
    if (this.animation) {
        this.animation.setScale(scale);
    }
};
SpineEffect.prototype.flip = function () {
    "use strict";
    if (this.animation) {
        return this.animation.flip();
    }
};
// handleRemove is called when the token is removed from the game.
SpineEffect.prototype.handleRemove = function () {
    "use strict";
    this.container.removeChild(this.animation);
    this.animation.free();
    this.animation = null;
};
// handleBeginStep is called each step before processing other events.
SpineEffect.prototype.handleBeginStep = function (timePassed) {
    "use strict";
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
SpineEffect.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
SpineEffect.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
SpineEffect.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
SpineEffect.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
SpineEffect.prototype.handleEndStep = function (timePassed) {
    "use strict";
    if (!this.finished) {
        return;
    }
    else {
        this.timeRemove -= timePassed;
    }
    if (this.timeRemove <= 0) {
        tbGame.removeToken(this);
    }
};
// handleDraw is called at the end of a step to draw the token.
SpineEffect.prototype.handleDraw = function () {
    "use strict";
};
